import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Dropdown from "../../../../controls/Dropdown";
import BackEnd from "../../../../backend/BackEnd";
import PlainDropdown from "../../../../controls/PlainDropdown";

class CompanyAddressRow extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired,
        addressTypes: PropTypes.array.isRequired,
        onUpdate: PropTypes.func.isRequired,
        onRemove: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        typeId: this.props.data.typeId,
        text: this.props.data.text,
        regionId: this.props.data.regionId,
        region: this.props.data.region
    };

    render() {
        const {onRemove} = this.props;
        return (
            <tr>
                <td>
                    <PlainDropdown class="form-control"
                                   placeholder="Тип"
                                   items={this.props.addressTypes}
                                   value={this.state.typeId}
                                   onChange={event => this.updateState({typeId: event.target.value})}/>
                </td>
                <td>
                    <input type="text" class="form-control"
                           placeholder="Адрес"
                           value={this.state.text}
                           onChange={event => this.updateState({text: event.target.value})}/>
                </td>
                <td>
                    <Dropdown className="form-control"
                              dataSource={new BackEnd.CompaniesAdmin.GetRegionsByTerm()}
                              item={this.state.region}
                              value={this.state.regionId}
                              onChange={event => this.updateState({regionId: event.target.value})}/>
                </td>
                <td>
                    <button type="button" className="btn btn default btn-outline"
                            onClick={() => onRemove()}>
                        <i className="fa fa-close"/>
                    </button>
                </td>
            </tr>
        );
    }

    updateState(state) {
        const {onUpdate} = this.props;

        this.setState(state, () => onUpdate(this.state));
    }
}

export default CompanyAddressRow;


// WEBPACK FOOTER //
// ./src/pages/Catalogs/Companies/components/CompanyAddressRow.js